export default __webpack_public_path__ + "static/leto-c99a434fbb412b7d272c06739c81ccfb.png";